module.exports = __webpack_public_path__ + "static/media/direction.30ad0274.svg";